import { html, SYSTableDefIds } from "../../../../../_ovlclient/src"
import { T } from "../../../../../_ovlclient/src/textapi"
import { SYSBaseElement } from "../../../../../_ovlclient/src/library/sysbaseelement"

export class CompSYSUserAdministrationPermission extends SYSBaseElement {
  async getUI() {
    return html`
      <ovl-table
        class="fd-table fd-table--no-horizontal-borders"
        .props=${() => <SYSTableDefIds>"SYSUserAdministration_Permission"}
      >
      </ovl-table>
    `
  }
}
